export const ApplicationId = "0B4466C9-8E64-4F83-A917-74478D7EBC0E"; //"7E84E687-8B74-465F-87F4-835553B75E17" //"0550572c-23e0-49f3-946d-6fcb67aaefff" //"344268cc-9b4e-4c32-b987-e7c4b0c32b50"; //"0B4466C9-8E64-4F83-A917-74478D7EBC0E";
export const Google_map_Key = "AIzaSyC6dUNz2Vry4dIPxtTmK5hnk3zGMV7Yq1M";

export const DealerProURL = "https://paving-api.azurewebsites.net/";
export const DealerDevURL = "https://paving-api-dev.azurewebsites.net/";

export const PRODURL = "https://paving-api.azurewebsites.net/"; //"https://vizybility-api.azurewebsites.net/"; //
export const TestURL = "https://paving-api-dev.azurewebsites.net/";
export const GraphAPI = "https://graph.microsoft.com/v1.0/users";

export const STSDev =
  "https://viz-security-token-service-dev.azurewebsites.net/";
export const STSProd = "https://sts.vizybility.net/";

export const ReCAPTCHA_sitekey = "6LcnLOUqAAAAAGwjj841SAAT1lC1GZ9fDSMb-8AF";

export const DefaultAssetID = 2;

export const DealerURL = PRODURL;
export const DealerPublicURL = DealerProURL;

export const vizybilityConfig = {
  STS_SIGNIN_URL: `${STSProd}connect/token`,
  STS_CLIENT_ID: "viz-auth-serv-client",
  STS_CLIENT_SECRET:
    "mmAm#GKxXeyz7rtP8htzU8r5y8kdg0YloqlSfH9#Vo9uSbq7zFZaIvvP4EE@Dh",
  STS_SCOPE: "viz-crm-web-api-resource",
  grant_type: "password",
  GenericWebUsername: "genericweb.paving@vizybility.net",
  GenericWebUserPassword: "Vizy@July0Six@",
};

export const POST_CONTACT_US = `${DealerPublicURL}DealerWebApp/SendContactEmail`;
export const SAVE_COMPANY_AND_CONTACT = `${DealerURL}Company/SaveCompanyWithContact`;
export const GET_CONTACT_TYPE = `${DealerURL}Lookup/GetContactTypes`;
export const GET_AZURE_TOKEN = `${DealerURL}/ThirdPartyService/GetAzureB2CEcommAccessToken`;
export const GET_GENERIC_USER_KEY = `${DealerURL}/Settings/GetSettingByKey?key=WebsiteGenericUser`;
export const GET_ASSET_TYPES = `${DealerURL}/Lookup/GetAssetTypes`;
export const GET_ASSET_STATUSES = `${DealerURL}/Lookup/GetAssetStatuses`;
export const GET_ASSET_ICON = `${DealerURL}/Lookup/GetIcon`;
export const GET_ASSET_MAKE = `${DealerURL}/Lookup/GetMakes`;

export const ADD_ASSET = `${DealerURL}Asset/SaveAsset`;
export const UPLOAD_IMG = `${DealerURL}Pictures/Upload`;
export const GET_PICTURES = `${DealerURL}Pictures/GetPictureByContext`;
export const SAVE_PICTURE = `${DealerURL}Pictures/SavePicture`;
export const SAVE_ASSET_ADVERTISEMENTS = `${DealerURL}Advertisement/SaveAssetAdvertisements`;
export const SAVE_ASSET_ADVERTISEMENTS_IMG = `${DealerURL}Advertisement/SaveAdvertismentAttachments`;

export const ADD_WATCH_LIST = `${DealerURL}Advertisement/SaveAdvertisementWatchList`;
export const GET_WATCH_LIST = `${DealerURL}Advertisement/GetPagedAdvertisementWatchList`;

export const GET_ASSET_ADVERTISEMENTS_BY_ASSET_ID = `${DealerURL}Advertisement/GetAssetAdvertisements`;
export const SET_MAIN_PICTURE = `${DealerURL}Pictures/SetMainPicture`;
export const GET_CONTACT = `${DealerURL}/Contact/GetContact`;
export const ADD_LOCATION = `${DealerURL}Location/SaveLocation`;
export const UNIT_SERIAL_NUM_VALIDATION = `${DealerURL}Asset/UnitSerialNumValidation`;
export const GET_LOCATION = `${DealerURL}Lookup/GetLocations`;
export const GET_ASSET_BY_ID = `${DealerURL}Asset/GetAsset`;
export const GET_COMPANIES = `${DealerURL}Company/GetPagedCompanies`;
export const GET_EXTRA_DATA_SCHEMA = `${DealerURL}ExtraData/GetExtraDataSchema`;
export const GET_EXTRA_DATA = `${DealerURL}ExtraData/GetExtraData`;
export const SAVE_EXTRA_DATA = `${DealerURL}ExtraData/SaveExtraData`;

export const GET_MACHINES_LIST = `${DealerPublicURL}DealerWebApp/GetInventory`;
export const GET_CATEGORY_LIST = `${DealerPublicURL}DealerWebApp/GetTierWiseAssetCategorizationSummary?applicationId=${ApplicationId}`;
export const GET_MAKE_LIST = `${DealerPublicURL}DealerWebApp/GetMakeList?applicationId=${ApplicationId}`;
export const GET_MODEL_LIST = `${DealerPublicURL}DealerWebApp/GetModelsByMakeIds`;
export const GET_MASTER_MODELS_BY_MAKE = `${DealerPublicURL}DealerWebApp/GetMasterModelsByMake`;
// export const GET_MASTER_MODELS_BY_MAKE = `https://vizybility-api-dev.azurewebsites.net/DealerWebApp/GetMasterModelsByMake`;
export const GET_MACHINES_DETAILS = `${DealerPublicURL}DealerWebApp/GetInventorySummaryById?applicationId=${ApplicationId}`;
export const POST_SAVE_LEAD = `${DealerPublicURL}DealerWebApp/SaveLeadFromWebsite`;
export const SEND_EMAIL = `${DealerPublicURL}DealerWebApp/SendPavingAdminEmail`;
export const GET_TESTIMONIAL = `${DealerPublicURL}DealerWebApp/GetTestimonialSummary`;

export const GET_PAGE_ASSET_LIST = `${DealerURL}Asset/GetPagedAssets`;

export const GET_CATEGORY_LIST_BY_ASSET = `${DealerURL}AssetCategorization/GetCategories?assetTypeId=${DefaultAssetID}`;
export const SAVE_ASSET_CATEGORI = `${DealerURL}AssetCategorization/SaveAssetCategorization`;

export const GET_COMPANY_BY_ID = `${DealerURL}Company/GetCompanyById`;
export const GETLOCATION_BY_COMPANYID = `${DealerURL}Lookup/GetLocationsWithoutDefaultCompany`;
export const GETUSER_BY_COMPANYID = `${DealerURL}Contact/GetContactsByCompanyId`;
export const GET_SALUTATIONS = `${DealerURL}Lookup/GetSalutations`;
export const GET_CONTACT_STATUSES = `${DealerURL}Lookup/GetContactStatuses`;

export const SAVE_CONTACT = `${DealerURL}Contact/SaveContact`;
export const GET_CONTACT_BY_ID = `${DealerURL}Contact/GetContact`;
export const GET_LOCATION_BY_ID = `${DealerURL}Location/GetLocation`;
export const SAVE_LOCATION = `${DealerURL}Location/SaveLocation`;
export const GET_LOCATION_TYPE = `${DealerURL}Lookup/GetLocationTypes`;
export const GET_COMPANY_TYPE = `${DealerURL}Lookup/GetCompanyTypes`;
export const GET_INDUSTRIES = `${DealerURL}Lookup/GetIndustries`;
export const CHECK_COMPANY_NAME = `${DealerURL}Company/CompanyNameValidation`;
export const SAVE_COMPANY = `${DealerURL}Company/SaveCompany`;
export const DUMMY_API_CALL = `${DealerURL}Lookup/DummyAPICall`;

// Auth API endpoints (legacy — kept for backwards compat)
export const AUTH_REGISTER = `${DealerURL}Account/Register`;
export const AUTH_FORGOT_PASSWORD = `${DealerURL}Account/ForgotPassword`;
export const AUTH_RESET_PASSWORD = `${DealerURL}Account/ResetPassword`;
export const AUTH_SEND_VERIFICATION_CODE = `${DealerURL}Account/SendVerificationCode`;
export const AUTH_VERIFY_CODE = `${DealerURL}Account/VerifyCode`;

export const ALLOWED_ROLES = ["EcommUser"];

// ─── VizybilityIdentity Auth API ──────────────────────────────────────────────
// export const VIZY_IDENTITY_BASE_URL = "https://vizy-identity-dev.azurewebsites.net/api/v1";
// production
export const VIZY_IDENTITY_BASE_URL =
  "https://paving-identity.azurewebsites.net/api/v1";

// Login
export const VIZY_AUTH_LOGIN = `${VIZY_IDENTITY_BASE_URL}/auth/login`;
// export const VIZY_AUTH_LOGIN_PHONE                  = `${VIZY_IDENTITY_BASE_URL}/auth/login/phone`;
export const VIZY_AUTH_LOGIN_VERIFICATION = `${VIZY_IDENTITY_BASE_URL}/auth/login/verification`;
// export const VIZY_AUTH_LOGIN_PHONE_VERIFICATION     = `${VIZY_IDENTITY_BASE_URL}/auth/login/phone/verification`;
export const VIZY_AUTH_LOGIN_VERIFICATION_RESEND = `${VIZY_IDENTITY_BASE_URL}/auth/login/verification/resend`;

// Logout
export const VIZY_AUTH_LOGOUT = `${VIZY_IDENTITY_BASE_URL}/auth/logout`;

// Token refresh
export const VIZY_AUTH_TOKEN_REFRESH = `${VIZY_IDENTITY_BASE_URL}/auth/token/refresh`;

// Registration
export const VIZY_AUTH_REGISTER = `${VIZY_IDENTITY_BASE_URL}/auth/register`;
export const VIZY_AUTH_REGISTER_VERIFICATION = `${VIZY_IDENTITY_BASE_URL}/auth/register/verification`;
export const VIZY_AUTH_REGISTER_VERIFICATION_RESEND = `${VIZY_IDENTITY_BASE_URL}/auth/register/verification/resend`;

// Ecomm-user email OTP (used in registration flow)
export const VIZY_AUTH_SEND_EMAIL_OTP = `${VIZY_IDENTITY_BASE_URL}/auth/ecomm-user/email/send-otp`;
export const VIZY_AUTH_VERIFY_EMAIL_OTP = `${VIZY_IDENTITY_BASE_URL}/auth/ecomm-user/email/verify-otp`;

// Password reset
export const VIZY_AUTH_PASSWORD_RESET_REQUEST = `${VIZY_IDENTITY_BASE_URL}/auth/password/reset/request`;
export const VIZY_AUTH_PASSWORD_RESET_VERIFICATION = `${VIZY_IDENTITY_BASE_URL}/auth/password/reset/verification`;
export const VIZY_AUTH_PASSWORD_RESET = `${VIZY_IDENTITY_BASE_URL}/auth/password/reset`;

// User Metadata
export const VIZY_USER_METADATA = `${VIZY_IDENTITY_BASE_URL}/usermetadata`;
export const VIZY_USER_PROFILE = `${VIZY_IDENTITY_BASE_URL}/userprofile`;

// Passkey
// export const VIZY_AUTH_PASSKEY_DISCOVER             = `${VIZY_IDENTITY_BASE_URL}/auth/passkey/discover`;
// export const VIZY_AUTH_PASSKEY_CHALLENGE            = `${VIZY_IDENTITY_BASE_URL}/auth/passkey/challenge`;
// export const VIZY_AUTH_PASSKEY_AUTHENTICATE         = `${VIZY_IDENTITY_BASE_URL}/auth/passkey/authenticate`;
// export const VIZY_AUTH_PASSKEY_AVAILABLE            = `${VIZY_IDENTITY_BASE_URL}/auth/passkey/available`;
